import { Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../helper components/Toast/toast.component.css';
import { RestrictedRoutes } from './RestrictedRoutes';
import { PrivateRoutes } from './PrivateRoutes';
import { AuthLayout } from '../Components/AuthLayout';
import {
  Login,
  Register,
  EmailVerified,
  Forgot,
  EnterpriseList,
  EmployeeList,
  UploadEmployee,
  UserManagement,
  UploadHistory,
  Setting,
  EnterpriseActivity,
  Reset,
} from '../Components/Components';
import { useSelector } from 'react-redux';
import { Dashboard } from '../Components/Dashboard/Dashboard';
import { EmployeeDataMapping } from '../Components/Enterprise/EnterpriseAdmin/employeeDataMapping/EmployeeDataMapping';

export const NavigatingRoutes = () => {
  const authReducer = useSelector((state) => state.authReducer);

  return (
    <>
      <AuthLayout>
        <Routes>
          <Route
            path="/"
            element={
              authReducer.role === '' ? (
                <Login />
              ) : authReducer.role !== 'ENTERPRISE_ADMIN' ? (
                <EmployeeList />
              ) : (
                <EnterpriseList />
              )
            }
          />
          <Route path="/user/login" element={<Login />} />
          <Route path="/user/register" element={<Register />} />
          <Route path="/user/forgot" element={<Forgot />} />
          <Route path="/user/reset" element={<Reset />} />

          <Route element={<RestrictedRoutes />}>
            <Route path="/user/email-verified" element={<EmailVerified />} />
          </Route>

          <Route element={<PrivateRoutes />}>
            <Route
              path="/enterprise/bond-admin/dashboard"
              element={<EnterpriseList />}
            />
            {/* <Route path='/' element={authReducer.role === 'bond-admin' ?<EnterpriseList /> : <EmployeeList />} /> */}
            <Route
              path="/"
              element={
                authReducer.role === 'ENTERPRISE_ADMIN' ? (
                  <EnterpriseList />
                ) : (
                  <EmployeeList />
                )
              }
            />
            <Route
              path="/enterprise/bond-admin/enterprise-activity"
              element={<EnterpriseActivity />}
            />
            <Route
              path="/enterprise/enterprise-admin/dashboard"
              element={<EmployeeList />}
            />
            <Route
              path="/enterprise/enterprise-admin/upload-employee"
              element={<UploadEmployee />}
            />
            <Route
              path="/enterprise/enterprise-admin/data-mapping"
              element={<EmployeeDataMapping />}
            />
            <Route
              path="/enterprise/enterprise-admin/user-management"
              element={<UserManagement />}
            />
            <Route
              path="/enterprise/enterprise-admin/upload-history"
              element={<UploadHistory />}
            />
            <Route path="/user/setting" element={<Setting />} />
          </Route>

          {/* <Route path='/user/Dashboard' element={authReducer.role === 'bond-admin' || authReducer.role === 'enterprise-admin' ? <Dashboard /> : <Login />} /> */}
          <Route
            path="/user/Dashboard"
            element={
              authReducer.role === 'ENTERPRISE_ADMIN' ? (
                <Dashboard />
              ) : (
                <Login />
              )
            }
          />
        </Routes>
      </AuthLayout>
      <ToastContainer
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable={false}
        pauseOnHover={false}
        theme="light"
        limit={3}
      />
    </>
  );
};
